var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatNameAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accordion"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1177 10.0337L3.87495 14.2765L2.81445 13.216L6.52695 9.50347L2.81445 5.79097L3.87495 4.73047L8.1177 8.97322C8.25831 9.11386 8.33729 9.3046 8.33729 9.50347C8.33729 9.70234 8.25831 9.89307 8.1177 10.0337Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNameAccordionIcon);
export default __webpack_public_path__ + "static/media/chat_name_accordion_icon.e3d93448a1c1fd3d1625fd71b6918ac8.svg";
export { ForwardRef as ReactComponent };